import React from 'react';
import { Button, Image, Text } from '@goodfynd/ui';
import { useRouter } from 'next/router';

import config from '../../../config';
import images from '../../../config/images';
import routes from '../../../config/routes';
import strings from '../../../config/strings';
import { useApp } from '../../../context/app-context';
import * as dateUtil from '../../../utils/date-util';
import { LikeButton } from '../..';
import CmsPageContent from '../../cms/CmsPageContent';
import ShareButton from '../../ShareButton';

import {
  StyledBlock,
  StyledContainer,
  StyledIconLabel,
  StyledName,
  StyledNextEventInfo,
  StyledNoEventsContainer,
  StyledQuickInfo,
} from './styles';
import type { EventInfoProps } from './types';

export default function EventInfo({ bookedDates, data }: EventInfoProps) {
  const router = useRouter();
  const { isLoggedIn } = useApp();
  const nextBooked = bookedDates[0];

  const location = data?.location?.address || '';

  const renderEventContent = () => {
    if (nextBooked) {
      return (
        <StyledNextEventInfo
          location={data.map.baseLocation}
          title={strings.labels.nextEvent}
        >
          <StyledIconLabel
            name="clock"
            label={
              <Text as="body1">
                Event Time:&nbsp;
                <span>
                  {nextBooked.startTime}
                  &nbsp;-&nbsp;
                  {nextBooked.endTime}
                  &nbsp;
                </span>
              </Text>
            }
          />

          <StyledIconLabel
            name="calendar"
            label={
              <Text>
                {dateUtil.format(
                  nextBooked.start,
                  config.dateFormats.weekDayMonthDayYearLong
                )}
              </Text>
            }
          />
        </StyledNextEventInfo>
      );
    }

    if (!isLoggedIn) {
      return (
        <StyledNoEventsContainer>
          <CmsPageContent slug="consumer-event-login" />
        </StyledNoEventsContainer>
      );
    }

    return (
      <StyledNoEventsContainer>
        <Image
          alt="No events image"
          height={200}
          src={images.misc.foodGalaxy}
          width={200}
        />
        <Text as="heading5" style={{ marginTop: 24 }}>
          {strings.titles.noUpcomingEvents}
        </Text>

        <Button
          onClick={() => router.push(routes.search.events)}
          style={{
            marginTop: 16,
            width: 238,
          }}
        >
          {strings.labels.viewMoreEvents}
        </Button>
      </StyledNoEventsContainer>
    );
  };

  return (
    <>
      <StyledContainer>
        <StyledBlock>
          <StyledName as="h1">{data.uniqueName}</StyledName>
          <StyledQuickInfo>{location}</StyledQuickInfo>
        </StyledBlock>

        <StyledBlock>
          <LikeButton
            count={data.likes}
            item={data}
            liked={data.liked}
            type="event"
          />

          <ShareButton
            text={`Check out ${data.uniqueName} on Goodfynd!`}
            title={data.uniqueName || data.name}
            url={data.shortUrl}
          />
        </StyledBlock>
      </StyledContainer>

      {renderEventContent()}
    </>
  );
}
